import { render, staticRenderFns } from "./c-comment-item.vue?vue&type=template&id=776c7f43&scoped=true&"
import script from "./c-comment-item.vue?vue&type=script&lang=js&"
export * from "./c-comment-item.vue?vue&type=script&lang=js&"
import style0 from "./c-comment-item.vue?vue&type=style&index=0&id=776c7f43&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776c7f43",
  null
  
)

export default component.exports